import type { SVGProps } from "react";
export interface HonorStarIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function HonorStarIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: HonorStarIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M2.875 14.904V2a1.125 1.125 0 0 1 2.25 0v12.904c0 .943.462 1.827 1.238 2.364l4.854 3.362a1.38 1.38 0 0 0 1.566 0l4.853-3.362a2.88 2.88 0 0 0 1.24-2.364V2a1.125 1.125 0 0 1 2.25 0v12.904a5.13 5.13 0 0 1-1.956 4.027l-.252.187-4.854 3.362a3.63 3.63 0 0 1-4.128 0l-4.853-3.362a5.13 5.13 0 0 1-2.208-4.214"
      />
      <path
        fill={color}
        d="M10.878 6.453a1.377 1.377 0 0 1 2.243 0l.106.177.838 1.667 1.882.271c1.034.148 1.537 1.365.9 2.183l-.144.157-1.35 1.292.318 1.822c.203 1.16-1.015 1.949-1.983 1.449l-1.689-.872-1.686.872c-.968.5-2.186-.29-1.983-1.449l.316-1.82-1.35-1.294c-.844-.81-.346-2.182.757-2.34l1.882-.27.838-1.668zm.803 3.381c-.165.33-.48.557-.845.61l-.672.095.473.452c.27.26.394.637.33 1.007l-.116.662.632-.327.125-.054c.295-.11.625-.092.908.054l.633.327-.116-.662c-.064-.37.06-.747.331-1.007l.472-.452-.671-.095a1.13 1.13 0 0 1-.847-.61L12 9.2l-.318.634ZM22 .875a1.125 1.125 0 0 1 0 2.25H2a1.125 1.125 0 0 1 0-2.25z"
      />
    </svg>
  );
}
